<template>
  <main id="login-page" class="login-page" v-if="$route.path === '/login'">
    <!-- Messaggi di errore e successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessageLogin"
      :class="{ 'success-message': true, show: successMessageLogin }"
    >
      {{ successMessageLogin }}
    </p> -->

    <div id="login-form">
      <form class="login-form" @submit.prevent="handleSubmit">
        <!-- Input email -->
        <input
          id="login-email"
          type="email"
          placeholder="Indirizzo email"
          v-model="email"
          autocomplete="email"
          required
        />

        <!-- Campo password con bottone/occhio -->
        <div class="password-field">
          <input
            :type="showPassword ? 'text' : 'password'"
            placeholder="Password"
            v-model="password"
            autocomplete="current-password"
            required
          />
          <!-- Occhio (o icona) per mostrare/nascondere la password -->
          <button
            type="button"
            class="toggle-password-button"
            @click="togglePassword"
          >
            <!-- Se showPassword è false, mostra icona occhio aperto. Altrimenti, occhio chiuso. -->
            <span v-if="!showPassword">
              <font-awesome-icon :icon="['fas', 'eye-slash']" />
            </span>
            <span v-else>
              <font-awesome-icon :icon="['fas', 'eye']" />
            </span>
          </button>
        </div>

        <!-- Link “Ho dimenticato la password” -->
        <div class="forgot-password">
          <router-link to="/login/verify-email"
            >Ho dimenticato la password</router-link
          >
        </div>

        <!-- Bottone di login -->
        <button id="login-button" type="submit">ACCEDI</button>

        <!-- Separatore -->
        <div class="login-divider"><span>oppure</span></div>

        <!-- Pulsante ufficiale "Sign in with Google" (renderizzato da GIS) -->
        <div id="google-signin-button" ref="googleBtn"></div>
      </form>
    </div>
  </main>
  <router-view></router-view>
</template>

<script>
import { useToast } from "vue-toast-notification";
// import axios from "@/axiosPlugin.mjs";
export default {
  setup() {
    const toast = useToast();
    return {
      toast,
    };
  },
  name: "LoginPage",
  data() {
    return {
      email: "",
      password: "",
      // errorMessage: "",
      // successMessageLogin: "",
      showPassword: false, // controlla se la password è visibile
    };
  },
  methods: {
    async handleSubmit() {
      // this.errorMessage = "";
      // this.successMessage = "";
      try {
        const payLoad = {
          email: this.email,
          password: this.password,
        };
        const response = await this.$axios.post("auth/login", payLoad);
        if (response.status === 200) {
          // this.successMessageLogin =
          this.toast.success(response.data.message);

          // Estrai il ruolo dall'oggetto operator
          const role = response.data.operator?.role;

          // Imposta il ruolo nello store
          this.$store.commit("SET_OPERATOR_ROLE", role);

          // Salva anche in localStorage per persistenza in caso di refresh
          localStorage.setItem("operatorRole", role);

          setTimeout(() => {
            // Se role === 'ceo' vai su /home
            if (role === "ceo") {
              this.$router.push("/home");
            }
            // Altrimenti, se role === 'employee' o 'collaborator', vai su /get-all-operator-quotes
            else if (role === "employee" || role === "collaborator") {
              this.$router.push("/operator-quotes");
            } else {
              // Se preferisci, puoi usare un fallback se il ruolo non corrisponde
              this.$router.push("/home");
            }
          }, 2500); // Rimanda alla home dopo 2.5 secondi
        }
      } catch (error) {
        // console.error("Errore durante il login: ", error);
        // Se lo status è 401 => Credenziali non valide
        if (error.response?.status === 401) {
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response?.data.details || "Email/password non corrette!"
          );
          // });
        } else {
          // altri errori generici
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response?.data?.error || "Credenziali non valide"
          );
          // });
        }
      }
    },
    togglePassword() {
      // Inverte lo stato showPassword
      this.showPassword = !this.showPassword;
    },
    // Inizializza Google Identity Services recuperando il Client ID dal backend.
    // La config viene scaricata UNA SOLA VOLTA; il polling riguarda solo window.google.
    async initGoogleSignIn() {
      // 1) Recupera il Client ID dal backend (sorgente unica, no .env frontend)
      let googleClientId;
      try {
        const { data } = await this.$axios.get("auth/google-login/config");
        googleClientId = data.googleClientId;

        // --- LOG TEMPORANEI (rimuovere dopo il test) ---
        const masked = googleClientId
          ? googleClientId.slice(0, 8) + "…" + googleClientId.slice(-12)
          : "(vuoto)";
        console.log("[GoogleLogin] endpoint config chiamato ✓");
        console.log("[GoogleLogin] clientId ricevuto:", masked);
        console.log(
          "[GoogleLogin] window.location.origin:",
          window.location.origin
        );
        // --- FINE LOG TEMPORANEI ---
      } catch (e) {
        console.error(
          "[GoogleLogin] impossibile recuperare la config Google:",
          e
        );
        return;
      }

      if (!googleClientId) {
        console.error(
          "[GoogleLogin] googleClientId mancante: GIS non inizializzato."
        );
        return;
      }

      // 2) Inizializza GIS dopo che lo script gsi/client è pronto.
      //    Il polling riguarda SOLO window.google, non la fetch della config.
      this.renderGoogleButton(googleClientId);
    },
    // Polling sul solo script GIS, poi initialize + renderButton
    renderGoogleButton(googleClientId) {
      if (
        !window.google ||
        !window.google.accounts ||
        !window.google.accounts.id
      ) {
        return setTimeout(() => this.renderGoogleButton(googleClientId), 100);
      }
      window.google.accounts.id.initialize({
        client_id: googleClientId,
        callback: this.handleGoogleCredential,
        auto_select: false,
      });
      window.google.accounts.id.renderButton(this.$refs.googleBtn, {
        theme: "outline",
        size: "large",
        text: "signin_with",
        width: 280,
      });
    },
    // Callback GIS: riceve l'ID token (credential) e lo invia al backend per la verifica
    async handleGoogleCredential(response) {
      if (!response || !response.credential) {
        this.toast.error("Login con Google annullato o non riuscito.");
        return;
      }
      try {
        // NB: il JWT NON viene decodificato lato client per autenticare.
        // È il backend a verificarlo e a impostare il cookie di sessione.
        const res = await this.$axios.post("auth/google-login", {
          credential: response.credential,
        });
        this.toast.success(res.data.message);

        const role = res.data.operator?.role;
        this.$store.commit("SET_OPERATOR_ROLE", role);
        localStorage.setItem("operatorRole", role);

        // Stesso redirect per ruolo del login classico
        if (role === "ceo") {
          this.$router.push("/home");
        } else if (role === "employee" || role === "collaborator") {
          this.$router.push("/operator-quotes");
        } else {
          this.$router.push("/home");
        }
      } catch (error) {
        const status = error.response?.status;
        if (status === 401 || status === 403 || status === 404) {
          this.toast.error(
            error.response?.data?.details ||
              "Account Google non autorizzato ad accedere."
          );
        } else {
          this.toast.error(
            error.response?.data?.error || "Errore durante il login con Google."
          );
        }
      }
    },
  },
  mounted() {
    this.initGoogleSignIn();
  },
};
</script>

<!-- Stesso file CSS (LoginPage.css) o un .vue con <style> -->
<style src="@/css/LoginPage.css"></style>
